'use strict';
/*eslint no-unused-vars: 0, no-extra-parens: 0*/
// Entry point for web application

////////////////
// BROWSERIFY //
//------------//

// With Browserify installed simply use:
//
// require('<node module>');
//
// or:
//
// require('modules/<custom module/<file>.js');
//
// or:
//
// require('<path/to/file>.js');


////////////////////////
// React + Browserify //
//--------------------//
//

import React from 'react';
import ReactDOM from 'react-dom';
import Handlebars from 'handlebars';

import App from './components/appComponent';
import AppByDiscipline from './components/appByDisciplineComponent';
import AppAllUnits from './components/appAllUnitsComponent';

import PageNotFound from './components/pageNotFoundComponent';

import ReactDOMServer from 'react-dom/server';

let DOM = React.DOM, body = DOM.body, div = DOM.div, script = DOM.script;

if (window !== undefined) {

  let components = [
    'App',
    'AppByDiscipline',
    'AppAllUnits'
  ];

  for (let i = 0, len = components.length; i < len; i++) {
    let componentName = components[i], //components[i].prototype.constructor.displayName;
        props = {},
        componentData = {},
        componentFactory;

    if(window.location.hostname === 'localhost') {
      props = {
        data:    (function() {
          let d = document.getElementById(componentName + '-initial-state' ),
            data = (d !== null) ? JSON.parse(d.innerHTML) : {};

          return data;
        })(),
        options: (function() {
          let d = document.getElementById(componentName + '-settings' ),
            data = (d !== null) ? JSON.parse(d.innerHTML) : {};

          return data;
        })()
      };
    }

    if (null !== document.getElementById(componentName)) {
      console.info('Loading component [%s] into [%s]', componentName, document.getElementById(componentName));

      componentData = ( window['APP_PROPS_'+componentName] === undefined ) ?
        props : window['APP_PROPS_'+componentName];

      // React render
      switch(componentName) {
      case 'App':
        componentFactory = React.createFactory(App);
        break;

      case 'AppByDiscipline':
        componentFactory = React.createFactory(AppByDiscipline);
        break;

      case 'AppAllUnits':
        componentFactory = React.createFactory(AppAllUnits);
        break;
      }

      ReactDOM.render(componentFactory(componentData), document.getElementById(componentName));
    }
  }

} else {
  const safeStringify = function(obj) {
    return JSON.stringify(obj).replace(/<\/script/g, '<\\/script').replace(/<!--/g, '<\\!--');
  };

  // var window = window || undefined;
  // var document = document || undefined;
  // var console = console || {'error':function(el){},'info':function(el){},'log':function(el){},'warn':function(el){}};
  // var settings = {"classification":""};
  // var template = "{{{markup}}}{{{state}}}";
  // var metaComponentName = "";
  // var _REST = {};
  // _REST.responses = [
  //   {body:"[]"},
  //   {body:"[]"}
  // ];

  var dataDegree = (_REST.responses === undefined) ? [] : JSON.parse(_REST.responses[0].body),
    dataDisc = (_REST.responses === undefined) ? [] : JSON.parse(_REST.responses[1].body),
    dataUnits = (_REST.responses === undefined || _REST.responses[2] === undefined) ? [] : JSON.parse(_REST.responses[2].body),
    dataOffers = (_REST.responses === undefined || _REST.responses[3] === undefined) ? [] : JSON.parse(_REST.responses[3].body),
    data = {
      degrees:     dataDegree,
      disciplines: dataDisc,
      units:       dataUnits,
      offerings: dataOffers
    };

    // its eval everything might go wrong lets catch exception and render 404
  var Component;

  switch(metaComponentName) {
  case 'App':
    Component = React.createFactory(App);
    break;

  case 'AppByDiscipline':
    Component = React.createFactory(AppByDiscipline);
    break;

  case 'AppAllUnits':
    Component = React.createFactory(AppAllUnits);
    break;

  default:
    Component = React.createFactory(PageNotFound);
    break;
  }

  var props = {
    data:    data,
    options: settings
  };

  var componentMarkup = ReactDOMServer.renderToString(
    div({id: metaComponentName, dangerouslySetInnerHTML: {__html:
        ReactDOMServer.renderToString( React.createElement(Component,props) )
    }}
  ));
  var componentData = ReactDOMServer.renderToString(
      script({dangerouslySetInnerHTML:
      {__html:'var APP_PROPS_'+metaComponentName+' = ' + safeStringify(props) + ';'}
    }));

  var processTemplate = Handlebars.compile(template); //compile
  print(processTemplate({markup:componentMarkup,state:componentData}));
}
